export default __webpack_public_path__ + "static/media/application_form_success.32ac36d1.svg";